module.exports = __webpack_public_path__ + "static/media/IMG_2665.8104a5da.JPG";